export enum CacheDatabase {
    Console = 'console',
    Project = 'project',
}
